import React from 'react';
import PropTypes from 'prop-types';
import DateRange from './DateRange';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import FilterCheckbox from './FilterCheckbox';
import ReportDownload from '../helpers/ReportDownload';

const GroupCohortsByOrganizationTypeFilter = ({
  meta,
  isLoading,
  periods,
  organizationTypes,
  onPeriodChange,
  onOrganizationTypeChange,
  onWithAgesChange,
  onWithAsqResultsChange,
  onCSVEnqueue,
  onCSVReportDetailsShow,
  csvReport,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className='row u-margin-top--base align-middle'>
        <div className='column small-12 medium-4 large-3 u-margin-top--base'>
          <Select
            isMulti
            isClearable
            name='sp-group-select'
            className={'o-select o-select--optgroup'}
            placeholder={t('filters.allOrganizationTypes')}
            disabled={isLoading}
            value={organizationTypes.filter(v => (meta.organizationTypes || '').split(',').map(i => parseInt(i)).includes(v.value))}
            onChange={(v) => onOrganizationTypeChange(v.map(i => i.value).join(','))}
            options={organizationTypes}
          />
        </div>
        <div className='column shrink align-self-middle u-margin-top--base'>
          <FilterCheckbox
            label={t('filters.withAgeRanges')}
            value={meta.withages || false}
            disabled={isLoading}
            onChange={onWithAgesChange}
          />
        </div>
        <div className='column shrink align-self-middle u-margin-top--base'>
          <FilterCheckbox
            label={t('filters.withAsqResults')}
            value={meta.withasq || false}
            disabled={isLoading}
            onChange={onWithAsqResultsChange}
          />
        </div>
      </div>
      <div className='row u-margin-bottom--large'>
        <div className='column small-12 u--margin-bottom'>
          <DateRange
            startDate={meta.start}
            endDate={meta.end}
            onDatesChange={onPeriodChange}
            periods={periods}
            disabled={isLoading}
          />
        </div>
      </div>
      <div className='row u-margin-bottom--small'>
        <div className='column shrink'>
          <a onClick={onCSVEnqueue}>
            <i className='fa fa-file-excel-o fa' aria-hidden="true"></i> {t('actions.generateCsv')}
          </a>
        </div>
        <div className='column grow'>
          <ReportDownload report={csvReport} onReportDetailsShow={onCSVReportDetailsShow}/>
        </div>
      </div>
    </div>
  );
};

GroupCohortsByOrganizationTypeFilter.propTypes = {
  meta: PropTypes.object.isRequired,
  periods: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  onOrganizationTypeChange: PropTypes.func.isRequired,
  organizationTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onWithAgesChange: PropTypes.func.isRequired,
  onWithAsqResultsChange: PropTypes.func.isRequired,
  onCSVEnqueue: PropTypes.func.isRequired,
  onCSVReportDetailsShow: PropTypes.func.isRequired,
  csvReport: PropTypes.object.isRequired,
}

export default GroupCohortsByOrganizationTypeFilter;
